import styled, { css } from 'styled-components';

const MENU_BACKGROUND = "white";
const TEXT_BLACK = "#444444";
const HIGHLIGHT_COLOR = "#e8e600";

export const UIContainer = styled.div`
  border: 1px solid lightgrey; /* fallback */
  border-color: rgba(0, 0,  0, 0.3);
  border-radius: 18px;
  background-color: ${MENU_BACKGROUND};
  position: fixed;
  top: 8px;
  left: 8px;
  font-size: 16px;
  width: 300px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 99;
  & img {
    max-width: 170px;
  }
`;

export const LoadingCurtain = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: white;

  z-index: 98;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  & ${UIContainer} {
    border: none;
  }

  /* https://loading.io/css/ - CC0 License <3 */
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;

    padding-bottom: 20vh; /* Slightly above center looks nicer imo */
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid ${HIGHLIGHT_COLOR};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${HIGHLIGHT_COLOR} transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const BreadcrumbContainer = styled.div`
  font-size: 18px;
  width: calc(100% - 12px);
  margin-bottom: 12px;
`;

export const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & ~ & {
    margin-top: 6px;
  }
`;

export const BasicButton = styled.div<{isActive:boolean}>`
  font-weight: lighter; 
  color: ${TEXT_BLACK};
  border-color: ${TEXT_BLACK};
  background-color: white;
  width: calc(100% - 12px);
  padding: 3px;
  box-sizing: border-box;
  margin-bottom: 6px;
  border: 1px solid ${TEXT_BLACK};
  border-radius: 18px;
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: ${HIGHLIGHT_COLOR};
  }

  ${(props) => props.isActive && css`
    background-color: ${HIGHLIGHT_COLOR};
  `}
`;

